import { FC, useEffect } from 'react';
import { parse } from 'query-string';
import { useAppSelector } from 'app/store';
import { useLocation } from 'react-router-dom';
import { ddlToOptions } from 'app/utils/utils';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { getCountries } from 'app/store/Countries/selectors';
import {
  getPasswordPolicy,
  getSignUpLink,
  getUserPersonasDDLLink,
} from 'app/store/Auth/selectors';
import { fetchPasswordPolicyEffect } from 'app/store/Auth/effects';
import { useFetch, useResource } from 'app/utils/hooks';
import { toCountryOptions } from 'app/components/Profile/ProfilePersonalSection/utils';
import { SignUpFormProps, UserPersonasDDLResponse } from './types';
import { SignUpFormComponent } from './SignUpFormComponent';

export const SignUpForm: FC<SignUpFormProps> = ({ afterSubmit }) => {
  const userPersonasDDLLink = useAppSelector(getUserPersonasDDLLink);
  const signUpLink = useAppSelector(getSignUpLink);
  const [countries] = useResource(fetchCountriesEffect, getCountries);
  const { search, pathname } = useLocation();
  const inviteToken = parse(search, { decode: false })?.inviteToken as string;
  const countryOptions = toCountryOptions(countries);
  const [passwordPolicy] = useResource(
    fetchPasswordPolicyEffect,
    getPasswordPolicy
  );

  const { callAPI: fetchPersonasDDL, data } = useFetch<
    {},
    UserPersonasDDLResponse
  >({
    withCredentials: false,
  });

  useEffect(() => {
    if (userPersonasDDLLink) {
      fetchPersonasDDL(userPersonasDDLLink.href);
    }
  }, [fetchPersonasDDL, userPersonasDDLLink]);

  return (
    <SignUpFormComponent
      signUpLink={signUpLink}
      afterSubmit={afterSubmit}
      userPersonas={ddlToOptions(data?.personas || {})}
      search={search}
      pathname={pathname}
      inviteToken={inviteToken}
      countryOptions={countryOptions}
      passwordPolicy={passwordPolicy}
    />
  );
};
